export const simpleGoalsTracker = {
  name: "Simple Goals Tracker",
  excerpt: "Manage Your Goals From Your Phone",
  image: "simpleLeadTracker.webp",
  localUrl: "simple-goals-tracker",
  url: "#",
  description: "Simple Goals Tracker does exactly what it says; it lets you plan goals as quickly and easily as possible. The app lets you define goals, track progress agaisnt them, and gives you data on how often you complete or fail a goal.",
  challenge: "The main challenge was building a very easy to use UI. We wanted the app to be quick to use, and then get out of the way. Too many apps take too long to figure out, and that defeats the purpose of an app that's meant to help you be more productive.",
  solution: "Another hybrid app, we built this one with Clojurescript and pacakges with Cordova. The app is currently available for IOS, but we have plans in the future to make it available for Android as well.",
  tech: ["Reagent", "Clojurescript", "Cordova"],
  images: ["simpleLeadTracker.webp", "simpleLeadTracker.webp", "simpleLeadTracker.webp"]
}
